(function () {
  window.GalleryBlockGrid = window.GalleryBlockGrid || {};

  var sectionSelector = '[data-gallery-block-grid]';
  var initializedAttribute = 'data-gallery-block-grid-initialized';
  var state = window.GalleryBlockGrid;

  state.openModalCount = state.openModalCount || 0;
  state.documentEventsBound = state.documentEventsBound || false;
  state.activeSection = state.activeSection || null;

  function setBodyScrollLock(shouldLock) {
    if (shouldLock) {
      state.openModalCount += 1;
      document.body.classList.add('gallery-block-grid-modal-open');
      return;
    }

    state.openModalCount = Math.max(0, state.openModalCount - 1);

    if (state.openModalCount === 0) {
      document.body.classList.remove('gallery-block-grid-modal-open');
    }
  }

  function getSectionElements(section) {
    return {
      modal: section.querySelector('[data-gallery-modal]'),
      modalPanel: section.querySelector('[data-gallery-modal-panel]'),
      modalImage: section.querySelector('[data-gallery-modal-image]'),
      modalLink: section.querySelector('[data-gallery-modal-link]'),
      triggers: section.querySelectorAll('[data-gallery-trigger]')
    };
  }

  function openModal(section, trigger) {
    var elements = getSectionElements(section);
    var imageSrc = trigger.getAttribute('data-gallery-image-src');
    var imageAlt = trigger.getAttribute('data-gallery-image-alt') || '';
    var linkUrl = trigger.getAttribute('data-gallery-link-url');

    if (!elements.modal || !elements.modalImage || !imageSrc) {
      return;
    }

    section.galleryBlockGridActiveTrigger = trigger;
    elements.modalImage.src = imageSrc;
    elements.modalImage.alt = imageAlt;

    if (elements.modalLink) {
      if (linkUrl) {
        elements.modalLink.href = linkUrl;
        elements.modalLink.hidden = false;
      } else {
        elements.modalLink.removeAttribute('href');
        elements.modalLink.hidden = true;
      }
    }

    elements.modal.hidden = false;
    elements.modal.setAttribute('aria-hidden', 'false');
    section.galleryBlockGridModalOpen = true;
    state.activeSection = section;
    setBodyScrollLock(true);

    var closeButton = section.querySelector('[data-gallery-close]');
    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeModal(section) {
    var elements = getSectionElements(section);

    if (!elements.modal || !section.galleryBlockGridModalOpen) {
      return;
    }

    elements.modal.hidden = true;
    elements.modal.setAttribute('aria-hidden', 'true');
    section.galleryBlockGridModalOpen = false;

    if (elements.modalImage) {
      elements.modalImage.removeAttribute('src');
      elements.modalImage.alt = '';
    }

    if (elements.modalLink) {
      elements.modalLink.removeAttribute('href');
      elements.modalLink.hidden = true;
    }

    setBodyScrollLock(false);

    if (state.activeSection === section) {
      state.activeSection = null;
    }

    if (
      section.galleryBlockGridActiveTrigger &&
      typeof section.galleryBlockGridActiveTrigger.focus === 'function'
    ) {
      section.galleryBlockGridActiveTrigger.focus();
    }
  }

  function bindDocumentEvents() {
    if (state.documentEventsBound) {
      return;
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && state.activeSection) {
        closeModal(state.activeSection);
      }
    });

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target) {
        return;
      }

      if (event.target.matches && event.target.matches(sectionSelector)) {
        initSection(event.target);
        return;
      }

      event.target.querySelectorAll(sectionSelector).forEach(initSection);
    });

    state.documentEventsBound = true;
  }

  function initSection(section) {
    if (!section || section.hasAttribute(initializedAttribute)) {
      return;
    }

    var elements = getSectionElements(section);

    if (!elements.modal || !elements.modalImage) {
      return;
    }

    elements.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(section, trigger);
      });
    });

    section.querySelectorAll('[data-gallery-close]').forEach(function (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.stopPropagation();
        closeModal(section);
      });
    });

    if (elements.modalLink) {
      elements.modalLink.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    elements.modal.addEventListener('click', function (event) {
      if (event.target === elements.modal) {
        closeModal(section);
      }
    });

    if (elements.modalPanel) {
      elements.modalPanel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    section.setAttribute(initializedAttribute, 'true');
  }

  function initAllSections() {
    bindDocumentEvents();
    document.querySelectorAll(sectionSelector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }
})();
